import react, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Checkbox,
  Pagination,
  IconButton, // added for icon button
  CircularProgress, // added for spinner
} from "@mui/material";
import SelectRow from "./SelectRow";
import { useSelector, useDispatch } from "react-redux";
import jMoment from "moment-jalaali";
import AddIcon from "@mui/icons-material/Add"; // added Add icon

const SelectTable = (props) => {
  const dispatch = useDispatch();
  // Read existing orders array from Redux store
  const ordersInStore = useSelector((state) => state.ReceiptReducer.orders);
  // Local loading state for the bulk-add operation
  const [loading, setLoading] = useState(false);

  const rowCount = 15;
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    props.getPage(value);
  };

  // Handler for “Add All” button click
  const handleAddAll = () => {
    setLoading(true);
    // Loop through visible orders and dispatch 'add' for each not already added
    props.data.forEach((order) => {
      // Check if this order is already in store (by orderId)
      const alreadyAdded = ordersInStore.some(
        (item) => item.orderId === order.id
      );
      if (!alreadyAdded) {
        dispatch({
          type: "add",
          payload: {
            orderId: order.id,
            startDate: jMoment(Number(order.startDate)).format("jYY/jMM/jDD"),
            boxNumber: order.boxNumber,
            patientName: order.patientName,
            doctorName: order.doctorName,
            orderTypeName: order.orderType,
            endDate: order.endDate
              ? jMoment(Number(order.endDate)).format("jYY/jMM/jDD")
              : "---",
            unitCount: order.unitCount,
            unitCost: order.unitPrice,
            totalCost: order.totalPrice,
            afterDiscount: order.totalPrice,
            details: [],
          },
        });
      }
    });
    setLoading(false);
  };
  return (
    <Box>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow variant="head">
              <TableCell align="justify">
                {loading ? (
                  <CircularProgress size={18} /> // spinner while adding
                ) : (
                  <IconButton
                    size="small"
                    onClick={handleAddAll}
                    aria-label="Add all visible orders"
                  >
                    <AddIcon color="secondary" />
                  </IconButton>
                )}
              </TableCell>
              <TableCell align="justify" style={{ fontSize: 18 }}>
                شماره جعبه
              </TableCell>
              <TableCell align="justify" style={{ fontSize: 18 }}>
                تاریخ شروع
              </TableCell>
              <TableCell align="justify" style={{ fontSize: 18 }}>
                نام بیمار
              </TableCell>
              <TableCell align="justify" style={{ fontSize: 18 }}>
                نام پزشک
              </TableCell>
              <TableCell align="justify" style={{ fontSize: 18 }}>
                نوع کار
              </TableCell>
              <TableCell align="justify" style={{ fontSize: 18 }}>
                تعداد واحد
              </TableCell>
              <TableCell align="justify" style={{ fontSize: 18 }}>
                تاریخ اتمام
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((order) => {
              return (
                <SelectRow
                  key={order.id}
                  orderId={order.id}
                  startDate={jMoment(Number(order.startDate)).format(
                    "jYY/jMM/jDD"
                  )}
                  boxNumber={order.boxNumber}
                  patientName={order.patientName}
                  doctorName={order.doctorName}
                  orderType={order.orderType}
                  unitCount={order.unitCount}
                  unitPrice={order.unitPrice}
                  totalPrice={order.totalPrice}
                  discountPrice={order.discountPrice}
                  endDate={
                    order.endDate
                      ? jMoment(Number(order.endDate)).format("jYY/jMM/jDD")
                      : "---"
                  }
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        sx={{ mt: 4, justifyContent: "center", display: "flex" }}
        count={props.pageCount}
        // page =  {page}
        onChange={handleChange}
      />
    </Box>
  );
};

export default SelectTable;
